import { createFileRoute, redirect } from "@tanstack/react-router";

import { getAuthStore } from "~/modules/auth/auth-store";

// keeping this since some folks are likely still navigating here
export const Route = createFileRoute("/landing")({
  component: RouteComponent,
  async beforeLoad() {
    const isLikelyLoggedIn = getAuthStore().getIsLikelyLoggedIn();

    if (isLikelyLoggedIn) {
      throw redirect({ to: "/home" });
    }

    throw redirect({ to: "/" });
  },
});

function RouteComponent() {
  return null;
}
